import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

interface CaseCreationState {
    caseDescription: string;
    deflectionResponse: string;
}

const initialState: CaseCreationState = {
    caseDescription: '',
    deflectionResponse: '',
};

const caseCreationSlice = createSlice({
    name: 'caseCreation',
    initialState,
    reducers: {
        setCaseCreation: (state, action: PayloadAction<{ caseDescription: string; deflectionResponse: string }>) => {
            state.caseDescription = action.payload.caseDescription;
            state.deflectionResponse = action.payload.deflectionResponse;
        },
        clearCaseCreation: (state) => {
            state.caseDescription = '';
            state.deflectionResponse = '';
        },
    },
});

export const selectCaseCreation = (state: RootState) => state.caseCreation;

export const { setCaseCreation, clearCaseCreation } = caseCreationSlice.actions;
export default caseCreationSlice.reducer;
